import React, { memo } from "react";
import { useI18n } from "Hooks";
import classes from "./StudentTranscriptCommentSkeleton.scss";
import SectionHeader from "../SectionHeader";
import SkeletonLoader from "UIComponents/SkeletonLoader";

const StudentTranscriptCommentSkeleton = () => {
  const { t } = useI18n();

  return (
    <div className={classes.commentContainer}>
      <SectionHeader
        lastSyncedText={t("transcript:last_updated_on")}
        isLoading
        title={t("common:note_plural")}
        subText={t("transcript:student_notes_subtext")}
      />
      <SkeletonLoader
        height="208px"
        width="100%"
        customClasses={classes.loader}
      />
    </div>
  );
};

export default memo(StudentTranscriptCommentSkeleton);
